import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FilterIcon, SearchIcon } from 'lucide-react';
import ProductCard from '../components/ProductCard';
import { Product } from '../context/CartContext';
const allProducts: Product[] = [{
  id: 1,
  name: 'Lavender Essential Oil',
  price: 'KSh 1,500',
  priceValue: 1500,
  rating: 5,
  reviews: 124,
  image: 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop',
  description: 'Pure lavender oil for relaxation and skin care.',
  badge: 'Best Seller',
  category: 'single'
}, {
  id: 2,
  name: 'Tea Tree Essential Oil',
  price: 'KSh 1,200',
  priceValue: 1200,
  rating: 4.5,
  reviews: 98,
  image: 'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=600&auto=format&fit=crop',
  description: 'Powerful antiseptic oil with cleansing properties.',
  category: 'single'
}, {
  id: 3,
  name: 'Eucalyptus Essential Oil',
  price: 'KSh 1,300',
  priceValue: 1300,
  rating: 4.8,
  reviews: 76,
  image: 'https://images.unsplash.com/photo-1600857544200-b2f468e9d10d?q=80&w=600&auto=format&fit=crop',
  description: 'Refreshing oil that promotes clear breathing.',
  badge: 'New',
  category: 'single'
}, {
  id: 4,
  name: 'Lemongrass Essential Oil',
  price: 'KSh 1,100',
  priceValue: 1100,
  rating: 4.7,
  reviews: 65,
  image: 'https://images.unsplash.com/photo-1601055283742-8b27e81b5553?q=80&w=600&auto=format&fit=crop',
  description: 'Citrusy oil that helps reduce stress.',
  category: 'single'
}, {
  id: 5,
  name: 'Peppermint Essential Oil',
  price: 'KSh 1,400',
  priceValue: 1400,
  rating: 4.9,
  reviews: 112,
  image: 'https://images.unsplash.com/photo-1600857462034-6cd98ca80095?q=80&w=600&auto=format&fit=crop',
  description: 'Cooling and refreshing oil for energy and focus.',
  category: 'single'
}, {
  id: 6,
  name: 'Rosemary Essential Oil',
  price: 'KSh 1,250',
  priceValue: 1250,
  rating: 4.6,
  reviews: 89,
  image: 'https://images.unsplash.com/photo-1595981267030-ca121bcf4df9?q=80&w=600&auto=format&fit=crop',
  description: 'Herbaceous oil that promotes mental clarity.',
  category: 'single'
}, {
  id: 7,
  name: 'Relaxation Blend',
  price: 'KSh 1,800',
  priceValue: 1800,
  rating: 4.8,
  reviews: 75,
  image: 'https://images.unsplash.com/photo-1608571423899-ec3cdb9a3a65?q=80&w=600&auto=format&fit=crop',
  description: 'A calming blend of lavender, chamomile, and ylang-ylang.',
  badge: 'Popular',
  category: 'blend'
}, {
  id: 8,
  name: 'Respiratory Blend',
  price: 'KSh 1,700',
  priceValue: 1700,
  rating: 4.7,
  reviews: 62,
  image: 'https://images.unsplash.com/photo-1608571423896-71e99248e144?q=80&w=600&auto=format&fit=crop',
  description: 'A clearing blend of eucalyptus, tea tree, and peppermint.',
  category: 'blend'
}, {
  id: 9,
  name: 'Ultrasonic Diffuser',
  price: 'KSh 3,500',
  priceValue: 3500,
  rating: 4.9,
  reviews: 128,
  image: 'https://images.unsplash.com/photo-1608571423897-d68e04b0d0b9?q=80&w=600&auto=format&fit=crop',
  description: 'Modern ultrasonic diffuser for essential oils with LED lights.',
  category: 'diffuser'
}, {
  id: 10,
  name: 'Ceramic Diffuser',
  price: 'KSh 2,800',
  priceValue: 2800,
  rating: 4.6,
  reviews: 93,
  image: 'https://images.unsplash.com/photo-1602928298849-325939ef8a9a?q=80&w=600&auto=format&fit=crop',
  description: 'Elegant ceramic diffuser with natural bamboo base.',
  category: 'diffuser'
}, {
  id: 11,
  name: 'Essential Oil Gift Set',
  price: 'KSh 4,500',
  priceValue: 4500,
  rating: 4.9,
  reviews: 156,
  image: 'https://images.unsplash.com/photo-1608571423898-d7b5fa08d966?q=80&w=600&auto=format&fit=crop',
  description: 'Collection of 6 popular essential oils in a beautiful gift box.',
  badge: 'Gift',
  category: 'gift'
}, {
  id: 12,
  name: 'Jojoba Carrier Oil',
  price: 'KSh 950',
  priceValue: 950,
  rating: 4.7,
  reviews: 84,
  image: 'https://images.unsplash.com/photo-1595981267006-5a2140753a5c?q=80&w=600&auto=format&fit=crop',
  description: 'Pure jojoba oil for diluting essential oils for topical use.',
  category: 'carrier'
}];
const categories = [{
  id: 'all',
  name: 'All Products'
}, {
  id: 'single',
  name: 'Single Oils'
}, {
  id: 'blend',
  name: 'Oil Blends'
}, {
  id: 'diffuser',
  name: 'Diffusers'
}, {
  id: 'gift',
  name: 'Gift Sets'
}, {
  id: 'carrier',
  name: 'Carrier Oils'
}];
const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [priceRange, setPriceRange] = useState([0, 5000]);
  const [showFilters, setShowFilters] = useState(false);
  const [sortBy, setSortBy] = useState('featured');
  const filteredProducts = allProducts.filter(product => {
    // Category filter
    if (selectedCategory !== 'all' && product.category !== selectedCategory) {
      return false;
    }
    // Search filter
    if (searchQuery && !product.name.toLowerCase().includes(searchQuery.toLowerCase()) && !product.description.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    // Price filter
    if (product.priceValue < priceRange[0] || product.priceValue > priceRange[1]) {
      return false;
    }
    return true;
  });
  // Sort products
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortBy === 'price-low') {
      return a.priceValue - b.priceValue;
    } else if (sortBy === 'price-high') {
      return b.priceValue - a.priceValue;
    } else if (sortBy === 'rating') {
      return b.rating - a.rating;
    }
    // Default: featured/newest
    return 0;
  });
  return <div className="bg-[#f8f9f4] min-h-screen w-full" data-id="element-908">
      <div className="bg-[#2e7d32] text-white py-16" data-id="element-909">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-910">
          <h1 className="text-4xl font-bold mb-4" data-id="element-911">Our Products</h1>
          <p className="text-lg max-w-2xl" data-id="element-912">
            Discover our premium collection of essential oils and diffusers,
            sourced directly from Kenya's rich landscapes.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-913">
        {/* Search and filter bar */}
        <div className="bg-white rounded-lg shadow-md p-4 mb-8" data-id="element-914">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-915">
            <div className="relative flex-grow max-w-md" data-id="element-916">
              <input type="text" placeholder="Search products..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none" data-id="element-917" />
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-918" />
            </div>
            <div className="flex items-center space-x-4" data-id="element-919">
              <div className="relative" data-id="element-920">
                <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="appearance-none pl-4 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none bg-white" data-id="element-921">
                  <option value="featured" data-id="element-922">Featured</option>
                  <option value="price-low" data-id="element-923">Price: Low to High</option>
                  <option value="price-high" data-id="element-924">Price: High to Low</option>
                  <option value="rating" data-id="element-925">Highest Rated</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-926">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-927">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-928"></path>
                  </svg>
                </div>
              </div>
              <button onClick={() => setShowFilters(!showFilters)} className="md:hidden flex items-center text-gray-600 border border-gray-300 rounded-lg px-4 py-2" data-id="element-929">
                <FilterIcon className="h-5 w-5 mr-2" data-id="element-930" />
                Filters
              </button>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-2 mt-4" data-id="element-931">
            {categories.map(category => <button key={category.id} onClick={() => setSelectedCategory(category.id)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${selectedCategory === category.id ? 'bg-[#2e7d32] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-932">
                {category.name}
              </button>)}
          </div>
          {/* Mobile filters */}
          {showFilters && <div className="mt-4 md:hidden" data-id="element-933">
              <div className="grid grid-cols-2 gap-2" data-id="element-934">
                {categories.map(category => <button key={category.id} onClick={() => setSelectedCategory(category.id)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${selectedCategory === category.id ? 'bg-[#2e7d32] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-935">
                    {category.name}
                  </button>)}
              </div>
              <div className="mt-4" data-id="element-936">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-937">
                  Price Range: KSh {priceRange[0]} - KSh {priceRange[1]}
                </label>
                <input type="range" min="0" max="5000" step="100" value={priceRange[1]} onChange={e => setPriceRange([priceRange[0], parseInt(e.target.value)])} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-938" />
              </div>
            </div>}
        </div>
        {/* Product count */}
        <div className="mb-6" data-id="element-939">
          <p className="text-gray-600" data-id="element-940">
            Showing {sortedProducts.length} products
          </p>
        </div>
        {/* Product grid */}
        {sortedProducts.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-941">
            {sortedProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-942" />)}
          </div> : <div className="text-center py-12" data-id="element-943">
            <p className="text-gray-600 text-lg mb-4" data-id="element-944">
              No products match your filters.
            </p>
            <button onClick={() => {
          setSelectedCategory('all');
          setSearchQuery('');
          setPriceRange([0, 5000]);
        }} className="text-[#2e7d32] font-medium hover:underline" data-id="element-945">
              Clear all filters
            </button>
          </div>}
      </div>
    </div>;
};
export default Products;